<template>
  <div>
    <X-Layout>
      <!-- 位置条 -->
      <div style="position: relative; display: flex; justify-content: space-between; height: 28px; line-height: 28px">
        <Breadcrumb>
          <BreadcrumbItem to="/home"> <Icon type="icon iconfont icon-xitong" /> 系统首页 </BreadcrumbItem>
          <BreadcrumbItem> <Icon type="icon iconfont icon-xitonghoutai" /> 系统管理 </BreadcrumbItem>
          <BreadcrumbItem> <Icon type="icon iconfont icon-sousuo" /> 查询设备 </BreadcrumbItem>
        </Breadcrumb>
      </div>

      <!-- 内容区域 -->
      <Card style="margin-top: 12px">
        <div class="searchBox">
          <div>
            <span class="mnSty">MN</span
            ><Input v-model.trim="searchContent" placeholder="请输入MN号" style="width: 300px">
              <Icon type="ios-search" slot="prefix" />
            </Input>
          </div>
          <div>
            <Button @click="searchDevice">搜索</Button>
          </div>
        </div>
        <div>
          <Table :columns="columns2" :data="data1" :loading="dataInfoLoading"></Table>
        </div>
      </Card>
    </X-Layout>
  </div>
</template>

<script>
import 'element-ui/lib/theme-chalk/index.css';
import { formatDateTime } from '@/common/common.js';
export default {
  data() {
    return {
      searchContent: '', // 搜索内容
      columns2: this.getTableTitle(), // 表头
      data1: [], // 表数据
      dataInfoLoading: false, // 信息加载动画
    };
  },
  methods: {
    // 获取表头
    getTableTitle() {
      return [
        {
          type: 'receive_id',
          title: 'receive_id',
          align: 'center',
          width: 120,
          render: (h, params) => {
            // 对比有无对应数据

            if (params.row[params.column.title]) {
              return h('div', params.row[params.column.title]);
            } else {
              return h('div', '--');
            }
          },
        },
        {
          type: 'content',
          title: 'content',
          minWidth: 300,
          render: (h, params) => {
            // 对比有无对应数据

            if (params.row[params.column.title]) {
              return h('div', { style: 'padding:10px 0;' }, params.row[params.column.title]);
            } else {
              return h('div', '--');
            }
          },
        },
        {
          type: 'time',
          title: 'time',
          align: 'center',
          width: 150,
          render: (h, params) => {
            // 对比有无对应数据

            if (params.row[params.column.title]) {
              return h('div', formatDateTime(params.row[params.column.title]));
            } else {
              return h('div', '--');
            }
          },
        },
      ];
    },
    // 搜索设备 Environmental/receiveData/getRecentReceivedData
    searchDevice() {
      if (!this.searchContent) {
        this.$Message.warning('请输入MN号');
        return;
      }
      let api = this.ApiUrl + 'receiveData/getRecentReceivedData';
      let data = {
        mn: this.searchContent,
      };
      this.dataInfoLoading = true; // 开启加载动画
      this.$http.post(api, data).then(
        res => {
          if (res.data.extend.news === 0) {
            this.data1 = res.data.extend.recentReceivedData;
          }

          this.dataInfoLoading = false; // 关闭加载动画
        },
        res => {
          this.dataInfoLoading = false; // 关闭加载动画
        },
      );
    },
  },
};
</script>

<style scoped>
.searchBox {
  display: flex;
  margin-bottom: 10px;
}

.searchBox > div {
  margin-right: 10px;
}
.mnSty {
  margin-right: 5px;
}
</style>
